// Convenience component that can be passed directly to @hookform/error-message's
// render function:
// <ErrorMessage errors={errors} name="field-name" render={FormValidationError} />

import { type ComponentPropsWithoutRef } from 'react';

import FormNote from './FormNote';

type FormValidationErrorProps = Omit<
  ComponentPropsWithoutRef<typeof FormNote>,
  'children' | 'status'
> & {
  message: string;
};

const FormValidationError = ({ message, ...props }: FormValidationErrorProps) => (
  <FormNote status="error" {...props}>
    {message}
  </FormNote>
);

export default FormValidationError;
